module.exports = __webpack_public_path__ + "img/details-right.d941530f.png";